<mat-card-title>
	Communication Events Report
	<help-text-btn class="align-help-text-btn" [helpTextId]="'CommunicationEventsReport_Overview'"></help-text-btn>
</mat-card-title>
<p style="line-height:0px;">&nbsp;</p>
<mat-divider> </mat-divider>
<br>
<div>
	<mat-card>
		<div class="row">
			<div class="col-lg-6"><mat-card-header>
					<mat-card-title>
						Search Criteria
					</mat-card-title>
				</mat-card-header>
				<mat-card-content>
					<region-dropdown-two-way [isMultiple]="true" [(selectedRegions)]="chosenRegions"
						[reset]="resetField" [required]="true" #appRegionCode>
					</region-dropdown-two-way>

					<county-dropdown-two-way [isMultiple]="true" [(selectedCounties)]="chosenCounties"
						[reset]="resetField" [required]="false" #appCountyCode [regions]="chosenRegions">
					</county-dropdown-two-way>

					<district-dropdown-two-way [isMultiple]="true" [(selectedSchoolDistricts)]="chosenSchoolDistricts"
						[reset]="resetField" [required]="false" #appSchoolDistrictCode [regions]="chosenRegions"
						[counties]="chosenCounties">
					</district-dropdown-two-way>

					<school-dropdown-two-way [isMultiple]="true" [(selectedSchools)]="chosenSchools"
						[reset]="resetField" #appSchoolsCode [regions]="chosenRegions" [counties]="chosenCounties"
						[schoolDistricts]="chosenSchoolDistricts">
					</school-dropdown-two-way>

					<app-school-year [yearType]="'SchoolYear'" (performancePeriodEvent)="performancePeriodEvent($event)"
						[reset]="resetField" [required]="true">
					</app-school-year>
				</mat-card-content>
				<mat-card-header>
					<mat-card-title>
						Enrollment Type *
						<help-text-btn class="align-help-text-btn" [helpTextId]="'EnrollmentType'"></help-text-btn>
					</mat-card-title>
				</mat-card-header>
				<mat-card-content>
					<div class="row">
						<mat-checkbox [color]="'primary'" [(ngModel)]="rAttending">
							Regular School Year - Attending</mat-checkbox>
						<mat-checkbox [color]="'primary'" [(ngModel)]="rNotAttending">
							Regular School Year - Not Attending</mat-checkbox>
					</div>
				</mat-card-content>
			</div>
			<div class="col-lg-6">
				<mat-card-header>
					<mat-card-title>
						Filters
					</mat-card-title>
				</mat-card-header>
				<mat-card-content>
					<div class="row">
						<mat-checkbox [color]="'primary'" [(ngModel)]="expiredEligibility">
							Include children without Eligibility in Period (EiP)</mat-checkbox>
						<mat-checkbox [color]="'primary'" [(ngModel)]="expiredQAD">
							Include children with expired QAD</mat-checkbox>
						<mat-checkbox [color]="'primary'" [(ngModel)]="noCommunicationEvent">
							Include children without a communication event</mat-checkbox>
					</div>
					<div class="row">
						<grade-dropdown [(chosenGrades)]="grades" (gradeEvent)="gradeEventEmitter($event)"
							[isMultiple]="true" [reset]="resetField">
						</grade-dropdown>
					</div>
					<div class="row">
						<dropdown [label]="'Select Communication Type(s)'" [objects]="communicationEventPurposeTypes"
							[path]="'TYPE'" (output)="communicationTypeEventEmitter($event)" [isMultiple]="true"
							[reset]="resetField">
						</dropdown>
					</div>
				</mat-card-content>
			</div>
		</div>
		<mat-card-actions>
			<button mat-raised-button color="primary" mat-button [disabled]="!this.checkValid() || isLoading"
				(click)="search()" class="margin-right-xs">
				<mat-icon *ngIf="isLoading">
					<mat-spinner diameter="18"> </mat-spinner>
				</mat-icon>
				Search
			</button>
			<button mat-raised-button color="accent" (click)="reset()" mat-button class="margin-right-xs">Reset</button>
			<button [disabled]="!(results.length > 0) || isExporting" mat-raised-button [matMenuTriggerFor]="menu"
				class="margin-right-xs">
				<mat-icon *ngIf="isExporting">
					<mat-spinner diameter="18"> </mat-spinner>
				</mat-icon>
				Export
				<mat-icon *ngIf="!isExporting">more_vert</mat-icon>
			</button>
			<mat-menu #menu="matMenu">
				<button mat-menu-item (click)="downloadExcel()">
					<span>
						<i class="fa fa-file"></i>
						Export to Excel</span>
				</button>
			</mat-menu>
		</mat-card-actions>
	</mat-card>
</div>

<app-msg [msg]="msg" *ngIf="!msg.SUCCESS"></app-msg>

<div *ngIf="results.length > 0" class="margin-top-md">
	<h2>
		Communication Events Report - {{'(' + currentSchoolYear + ')'}} - ({{(
		tableDataSource ? (tableDataSource.filteredData.length < results.length ? tableDataSource.filteredData.length
			+ '/' : '' ) : '' ) + results.length}} Children) </h2>
			<hr />

			<div class="row">
				<mat-form-field class="col-lg-12">
					<mat-label>
						Filter
					</mat-label>
					<input matInput id="filter" name="filter" type="string" [(ngModel)]="filter"
						(ngModelChangeDebounced)="setFilter()" />
				</mat-form-field>
			</div>

			<div class="margin-top-sm table-responsive">
				<mat-table [dataSource]="tableDataSource" class="mat-elevation-z1" matSort
					(matSortChange)="announceSortChange($event)">

					<ng-container matColumnDef="DISTRICT_NAME">
						<mat-header-cell *matHeaderCellDef mat-sort-header> District </mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.DISTRICT_NAME}} </mat-cell>
					</ng-container>

					<ng-container matColumnDef="SCHOOL_NAME">
						<mat-header-cell *matHeaderCellDef mat-sort-header> School </mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.SCHOOL_NAME}} </mat-cell>
					</ng-container>

					<ng-container matColumnDef="GRADE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Grade </mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.GRADE}} </mat-cell>
					</ng-container>

					<ng-container matColumnDef="ENROLLMENT_TYPE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Enroll Type </mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.ENROLLMENT_TYPE}} </mat-cell>
					</ng-container>

					<ng-container matColumnDef="MSD_NUMBER">
						<mat-header-cell *matHeaderCellDef mat-sort-header> MSD Number </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<edit-child-modal-btn [studentId]="element.ID" [type]="'string'"
								[displayText]="element.MSD_NUMBER">
							</edit-child-modal-btn>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="SSID">
						<mat-header-cell *matHeaderCellDef mat-sort-header> SSID </mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.SSID}}</mat-cell>
					</ng-container>

					<ng-container matColumnDef="PERSON.LAST_NAME">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.PERSON.LAST_NAME |
							titlecase}}{{(element.SECOND_LAST_NAME
							? ' ' + element.SECOND_LAST_NAME + ',': ',') | titlecase}} {{element.PERSON.FIRST_NAME |
							titlecase}}
							{{element.PERSON.MIDDLE_INITIAL | titlecase}}</mat-cell>
					</ng-container>

					<ng-container matColumnDef="DOB">
						<mat-header-cell *matHeaderCellDef mat-sort-header> DOB </mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.DOB | simpleDate}}
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="QAD">
						<mat-header-cell *matHeaderCellDef mat-sort-header> QAD </mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.QAD | simpleDate}}
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="ELIGIBILITY_END_DATE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> EoE </mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.ELIGIBILITY_END_DATE | simpleDate}}
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="DEPARTURE_DATE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Departure Date </mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.DEPARTURE_DATE | simpleDate}}
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="EIP_STATUS">
						<mat-header-cell *matHeaderCellDef mat-sort-header> EiP </mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.EIP_STATUS}}
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="COMMUNICATION_TYPE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Communication Type </mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.COMMUNICATION_TYPE}}
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="COMMUNICATION_DATE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Comm. Date </mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.COMMUNICATION_DATE | simpleDate}}
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="RESIDENCY_VERIFIED">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Residency Verified </mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.RESIDENCY_VERIFIED}}
						</mat-cell>
					</ng-container>

					<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
					<mat-row *matRowDef="let row; columns: displayedColumns;"
						[ngClass]="{'terminatedRow': row.ELIGIBILITY_END_DATE && isQadExpired(row.ELIGIBILITY_END_DATE)}"
						[matTooltip]="'QAD Expired'" [matTooltipPosition]="'above'"
						[matTooltipDisabled]="row.ELIGIBILITY_END_DATE && !isQadExpired(row.ELIGIBILITY_END_DATE)"
						[matTooltipClass]="'terminatedTooltip'"></mat-row>
				</mat-table>

			</div>
			<mat-paginator #paginators [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons
				aria-label="Select page of periodic elements">
			</mat-paginator>
</div>